export enum ServerStatusCode {
  noResponse = 0, // no HTTP response: connection lost, request blocked or aborted
  noContent = 204,
  commonError = 400,
  authorizeError = 401,
  forbiddenError = 403,
  notFoundError = 404,
  notAcceptable = 406,
  validationError = 422,
  customError = 409, // processed locally in components
  tooManyRequests = 429, // API rate limit
}
